import React from 'react';
import PropTypes from 'prop-types';

import styles from './formUserProfile.module.css';
import { roAPI } from '#utils/axiosAPI';
import { Input } from '../../UI/input/input';
import { Controller, useForm } from 'react-hook-form';
import { Field, FieldError, FieldLabel } from '../../UI/form/form';

const FormUserProfile = ({ currentUser, afterSubmit }) => {
  const form = useForm({
    defaultValues: {
      name: currentUser?.name || '',
      last_name: currentUser?.last_name || '',
      email: currentUser?.email || '',
      phone_number: currentUser?.phone_number || '',
      password: '',
      password2: '',
    },
    mode: 'onChange',
  });

  const handleFormSubmit = async data => {
    try {
      await roAPI.put('/user', {
        name: data.name,
        last_name: data.last_name,
        ...(data.phone_number && { phone_number: data.phone_number }),
        ...(data.password && { password: data.password }),
      });
      if (data.email && currentUser.email !== data.email) {
        await roAPI.put('/user/email', {
          email: data.email,
        });
      }
      afterSubmit();
    } catch (error) {
      // handle error if needed
    }
  };

  return (
    <div data-testid="FormUserProfile">
      <form className={styles.form} onSubmit={form.handleSubmit(handleFormSubmit)} id="formUser">
        <div className={styles['field-group']}>
          <Controller
            control={form.control}
            name="name"
            rules={{
              required: {
                value: true,
                message: 'El nombre es obligatorio.',
              },
            }}
            render={({ field, fieldState }) => (
              <div className="col-12 col-md-4">
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel data-invalid={fieldState.invalid} htmlFor="name">
                    Nombre
                  </FieldLabel>
                  <Input {...field} id="name" aria-invalid={fieldState.invalid} placeholder="Nombre" autoComplete="given-name" />
                  {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
                </Field>
              </div>
            )}
          />

          <Controller
            control={form.control}
            name="last_name"
            rules={{
              required: {
                value: true,
                message: 'Los apellidos son obligatorios.',
              },
            }}
            render={({ field, fieldState }) => (
              <div className="col-12 col-md-4">
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel data-invalid={fieldState.invalid} htmlFor="last_name">
                    Apellidos
                  </FieldLabel>
                  <Input {...field} id="last_name" aria-invalid={fieldState.invalid} placeholder="Apellidos" autoComplete="family-name" />
                  {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
                </Field>
              </div>
            )}
          />

          <Controller
            control={form.control}
            name="email"
            rules={{
              required: {
                value: true,
                message: 'El correo electrónico es obligatorio.',
              },
              pattern: { value: /^\S+@\S+$/i, message: 'El correo electrónico es inválido.' },
            }}
            render={({ field, fieldState }) => (
              <div className="col-12 col-md-4">
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel data-invalid={fieldState.invalid} htmlFor="email">
                    Correo electrónico
                  </FieldLabel>
                  <Input {...field} id="email" aria-invalid={fieldState.invalid} placeholder="Correo electrónico" autoComplete="on" />
                  {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
                </Field>
              </div>
            )}
          />

          <Controller
            control={form.control}
            name="phone_number"
            rules={{
              pattern: {
                value: /^\d{7,10}$/,
                message: 'Número de teléfono inválido.',
              },
            }}
            render={({ field, fieldState }) => (
              <div className="col-12 col-md-4">
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel data-invalid={fieldState.invalid} htmlFor="phone_number">
                    Número de télefono
                  </FieldLabel>
                  <Input
                    {...field}
                    id="phone_number"
                    aria-invalid={fieldState.invalid}
                    placeholder="Número de télefono"
                    autoComplete="tel"
                    maxLength={10}
                  />
                  {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
                </Field>
              </div>
            )}
          />

          <Controller
            control={form.control}
            name="password"
            render={({ field, fieldState }) => (
              <div className="col-12 col-md-4">
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel data-invalid={fieldState.invalid} htmlFor="password">
                    Contraseña
                  </FieldLabel>
                  <Input
                    {...field}
                    id="password"
                    aria-invalid={fieldState.invalid}
                    type="password"
                    placeholder="Contraseña"
                    autoComplete="new-password"
                  />
                  {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
                </Field>
              </div>
            )}
          />

          <Controller
            control={form.control}
            name="password2"
            rules={{
              validate: value => value === form.getValues('password') || 'La contraseña no coincide.',
            }}
            render={({ field, fieldState }) => (
              <div className="col-12 col-md-4">
                <Field data-invalid={fieldState.invalid}>
                  <FieldLabel data-invalid={fieldState.invalid} htmlFor="password2">
                    Confirmar contraseña
                  </FieldLabel>
                  <Input
                    {...field}
                    id="password2"
                    aria-invalid={fieldState.invalid}
                    type="password"
                    placeholder="Confirmar contraseña"
                    autoComplete="new-password"
                  />
                  {fieldState.invalid && <FieldError errors={[fieldState.error]} />}
                </Field>
              </div>
            )}
          />

          <div className="col-12">
            <p style={{ color: '#777' }}>* Si no desea cambiar su contraseña deje los campos vacios.</p>
          </div>
        </div>

        <button type="submit" className={`btn btn-une ${styles['btn-submit']}`}>
          Guardar cambios
        </button>
      </form>
    </div>
  );
};

FormUserProfile.propTypes = {
  currentUser: PropTypes.any,
  afterSubmit: PropTypes.func,
};

FormUserProfile.defaultProps = {
  currentUser: {},
  afterSubmit: f => f,
};

export default FormUserProfile;
